import React from 'react';
import { VStack, Box, Text, useMediaQuery } from '@chakra-ui/react';
import { useFormContext } from 'react-hook-form';
import { ChakraSelectField } from 'app/components/Core/ChakraSelectField';
import { ChakraTextareaField } from 'app/components/Core/ChakraTextareaField';
import { breakpoints } from 'app/constants';
import { DeleteAccountForm } from '../types';
import { reasonList } from '../constants';

interface DeleteAccountReasonStepProps {
  showOtherTextField: boolean;
}

export const DeleteAccountReasonStep = ({
  showOtherTextField,
}: DeleteAccountReasonStepProps) => {
  const {
    formState: { errors },
    control,
    trigger,
    register,
  } = useFormContext<DeleteAccountForm>();

  const reasonListOptions = reasonList.map((reason: string, index: number) => {
    return {
      title: reason,
      key: index,
      value: reason,
    };
  });

  const [isMobileView] = useMediaQuery(
    `(max-width: ${breakpoints.mobileScreen}px)`
  );
  const labelProps = isMobileView
    ? {
        sx: {
          fontSize: 'xxs !important',
          my: '16px !important',
        },
      }
    : undefined;

  return (
    <VStack w="full">
      <Box>
        <Text
          fontSize="sm"
          lineHeight="24px"
          letterSpacing="0.15px"
          color="M.70"
          pb={2}
        >
          Thank you for being a valuable member of the Session Studio community.
        </Text>
        <Text
          fontSize="sm"
          lineHeight="24px"
          letterSpacing="0.15px"
          color="M.70"
          py={4}
        >
          We are sorry to see you go and if there is anything we can improve,
          any feedback you have that would make you reconsider, please let us
          know.
        </Text>
      </Box>
      <ChakraSelectField
        dataTestId="delete-account-reason-select"
        label="Why are you deleting your account?"
        name="reason"
        menuPosition="fixed"
        control={control}
        options={reasonListOptions}
        onChange={() => {
          if (errors.otherReason) {
            trigger('otherReason');
          }
        }}
        labelProps={labelProps}
      />
      {showOtherTextField && (
        <Box zIndex={0} m={0} width="100%">
          <ChakraTextareaField
            label="Reason"
            isInvalid={Boolean(errors?.otherReason)}
            errorMessage={errors?.otherReason?.message}
            width="100%"
            resize="none"
            wordBreak="break-word"
            formControlStyleProps={{ mt: '16px !important' }}
            data-testid="delete-account-other-reason"
            labelProps={{
              'data-testid': 'delete-account-other-reason-label',
              my: '16px !important',
            }}
            {...register('otherReason')}
          />
        </Box>
      )}
    </VStack>
  );
};
